module.exports = __webpack_public_path__ + "img/birthday.306a23d7.gif";